import { render, staticRenderFns } from "./UserLog.vue?vue&type=template&id=24137f45&"
import script from "./UserLog.vue?vue&type=script&lang=js&"
export * from "./UserLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports